export default "__VITE_ASSET__wWesn5gR__"